import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { t } from '../utils/translations';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const {
    lang
  } = useLanguage();
  const text = t[lang].faq;
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-20 bg-gray-50 border-t border-gray-200" data-id="element-127">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="text-center mb-12" data-id="element-129">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-condensed font-black text-mf-black uppercase tracking-tight mb-4" data-id="element-130">
            {text.title}
          </motion.h2>
          <div className="w-24 h-1.5 bg-mf-red mx-auto" data-id="element-131"></div>
        </div>

        <div className="space-y-4" data-id="element-132">
          {text.items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden" data-id="element-133">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex justify-between items-center focus:outline-none bg-white hover:bg-gray-50 transition-colors" data-id="element-134">
                <span className="text-lg md:text-xl font-bold text-mf-black text-left pr-8" data-id="element-135">
                  {item.q}
                </span>
                <ChevronDown className={`flex-shrink-0 text-mf-red transition-transform duration-300 ${openIndex === index ? 'transform rotate-180' : ''}`} size={24} data-id="element-136" />
              </button>

              <AnimatePresence data-id="element-137">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              type: 'spring',
              stiffness: 100,
              damping: 15
            }} data-id="element-138">
                    <div className="px-6 pb-5 pt-0 border-t border-gray-100 border-l-4 border-l-mf-red" data-id="element-139">
                      <p className="text-gray-600 mt-4 text-lg" data-id="element-140">{item.a}</p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}